import { createContext, useContext, useState, useCallback } from "react";

const ThemeContext = createContext(null);
export const useTheme = () => useContext(ThemeContext);

export const ThemeProvider = ({ children }) => {
  const [dark, setDark] = useState(() => localStorage.getItem("studio_theme") === "dark");

  const toggle = useCallback(() => {
    setDark((d) => {
      const next = !d;
      localStorage.setItem("studio_theme", next ? "dark" : "light");
      document.documentElement.classList.toggle("dark", next);
      return next;
    });
  }, []);

  // Apply on mount
  if (dark) document.documentElement.classList.add("dark");

  return (
    <ThemeContext.Provider value={{ dark, toggle }}>
      {children}
    </ThemeContext.Provider>
  );
};
